export const categories = [
  {
    name: "E60/E61",
    children: [
       { name: "Alusta ja ohjaus", 
        children: [
            {name:"Hammastangot ja osat", children: []},
            {name:"Helat", children: []},
        ] },
        
      { name: "Jarrut", 
        
        children: [
            {name:"ABS-anturit, -kehät ja ohjausyksiköt", children: []},
            {name:"Jarrulevyt", children: []},
            {name:"Jarrupalat", children: []},
        ] },
      { name: "Jäähdytys ja lämmitys", 
        children: [
            {name:"Ilmastointilaitteet", children: []},
            {name:"Jäähdyttimet", children: []},
            
        ] },
      { name: "Kori", 
        children: [
            {name:"Peilit", children: []},
            {name:"Peltiosat, ovet, konepellit", children: []},
            {name:"Pohjapanssarit, sisälokasuojat", children: []},
            {name:"Puskurit, listat ja helmat", children: []},
        ] },
      { name: "Mittarit",
         children: [
            {name:"Mittaristot", children: []},
         ] },
      { name: "Moottorit ja osat",
         children: [
            {name:"Moottorit", children: []},
         ] },
      { name: "Renkaat ja vanteet"},
      { name: "Sisusta",
         children: [
            {name:"Kojelaudat ja listat", children: []},
            {name:"Lattiamatot ja muut verhoilut", children: []},
            {name:"Penkit, ovipahvit ja kattoverhoilut", children: []},
            {name:"Ratit, polkimet, akselit ja vivusto", children: []},
         ] },
      { name: "Valaistus",
         children: [
            {name:"Ajovalot", children: []},
            {name:"Sumuvalot", children: []},
            {name:"Takavalot, jarruvalot", children: []},
            {name:"Valomoduulit", children: []},
         ] },
        { name: "Voimansiirto ja vaihteisto",
         children: [
            {name:"Kardaanit", children: []},
            {name:"Perät ja jakolaatikot", children: []},
            {name:"Vaihteistot ja kytkimet", children: []},
            {name:"Vetoakselit", children: []},
         ] },
    ]
  },
  {
    name: "E90/E91/E92/E93",
    children: [
       { name: "Alusta ja ohjaus", 
        children: [
            {name:"Hammastangot ja osat", children: []},
            {name:"Helat", children: []},
        ] },
        
      { name: "Jarrut", 
        
        children: [
            {name:"ABS-anturit, -kehät ja ohjausyksiköt", children: []},
            {name:"Jarrulevyt", children: []},
            {name:"Jarrupalat", children: []},
        ] },
      { name: "Jäähdytys ja lämmitys", 
        children: [
            {name:"Ilmastointilaitteet", children: []},
            {name:"Jäähdyttimet", children: []},
            
        ] },
      { name: "Kori", 
        children: [
            {name:"Peilit", children: []},
            {name:"Peltiosat, ovet, konepellit", children: []},
            {name:"Pohjapanssarit, sisälokasuojat", children: []},
            {name:"Puskurit, listat ja helmat", children: []},
        ] },
      { name: "Mittarit",
         children: [
            {name:"Mittaristot", children: []},
         ] },
      { name: "Moottorit ja osat",
         children: [
            {name:"Moottorit", children: []},
         ] },
      { name: "Renkaat ja vanteet"},
      { name: "Sisusta",
         children: [
            {name:"Kojelaudat ja listat", children: []},
            {name:"Lattiamatot ja muut verhoilut", children: []},
            {name:"Penkit, ovipahvit ja kattoverhoilut", children: []},
            {name:"Ratit, polkimet, akselit ja vivusto", children: []},
         ] },
      { name: "Valaistus",
         children: [
            {name:"Ajovalot", children: []},
            {name:"Sumuvalot", children: []},
            {name:"Takavalot, jarruvalot", children: []},
            {name:"Valomoduulit", children: []},
         ] },
        { name: "Voimansiirto ja vaihteisto",
         children: [
            {name:"Kardaanit", children: []},
            {name:"Perät ja jakolaatikot", children: []},
            {name:"Vaihteistot ja kytkimet", children: []},
            {name:"Vetoakselit", children: []},
         ] },
    ]
  },
];
